export default __webpack_public_path__ + "static/media/CPNAA.d1702d24.png";